import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectTouchpointsPage } from './select-touchpoints.page';

const routes: Routes = [
  {
    path: '',
    component: SelectTouchpointsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectTouchpointsPageRoutingModule {}
